export interface ScreenshotReferencePoint {
  xRatio: number;
  yRatio: number;
}

const PIN_RADIUS_PX = 8;
const PIN_FILL_COLOR = '#d61e17'; // red-50
const PIN_STROKE_COLOR = '#ffffff';

// Composites a small pin onto an already-captured screenshot at the ratio position the
// user right-clicked, so reviewers see exactly where on the image to look.
export async function drawReferencePin(screenshotDataUrl: string, point: ScreenshotReferencePoint): Promise<string> {
  const image = new Image();
  image.src = screenshotDataUrl;
  await image.decode();

  const canvas = new OffscreenCanvas(image.naturalWidth, image.naturalHeight);
  const ctx = canvas.getContext('2d');
  if (!ctx) return screenshotDataUrl;

  ctx.drawImage(image, 0, 0);
  ctx.beginPath();
  ctx.arc(point.xRatio * image.naturalWidth, point.yRatio * image.naturalHeight, PIN_RADIUS_PX, 0, Math.PI * 2);
  ctx.fillStyle = PIN_FILL_COLOR;
  ctx.fill();
  ctx.lineWidth = 2;
  ctx.strokeStyle = PIN_STROKE_COLOR;
  ctx.stroke();

  const blob = await canvas.convertToBlob({ type: 'image/jpeg', quality: 0.9 });
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => resolve(reader.result as string));
    reader.addEventListener('error', () =>
      reject(reader.error ?? new Error('Failed to read composited screenshot as data URL')),
    );
    reader.readAsDataURL(blob);
  });
}
